import React from 'react';

const SnoozeCalendar = ({ className, style, ...props }) => (
  <svg
    className={className}
    style={style}
    {...props}
    width="18"
    height="18"
    viewBox="1 1.15 17.89 17.89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.4028 7.37308L14.3999 11.3701L10.4028 15.3672" stroke="#9c9c9c" strokeWidth="1" />
    <path d="M13.8449 11.3702H5.73975" stroke="#9c9c9c" strokeWidth="1.2" />
    <rect
      x="2.28625"
      y="3.0831"
      width="15.5675"
      height="15.517"
      rx="1.11111"
      stroke="#9c9c9c"
      strokeWidth="1.2"
    />
    <path d="M12.2378 1.4996V4.55231" stroke="#9c9c9c" strokeWidth="1.2" />
    <path d="M7.76282 1.4996V4.55231" stroke="#9c9c9c" strokeWidth="1.2" />
  </svg>
);

export default SnoozeCalendar;
